import React from 'react'

class StylizedEmoji extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24">
        <path
          fill="white"
          d="M12 16a4.045 4.045 0 0 0 3.225-1.632 1 1 0 1 1 1.55 1.264 6 6 0 0 1-9.55 0 1 1 0 0 1 1.55-1.264A4.045 4.045 0 0 0 12 16zM1 12a11 11 0 1 1 11 11A11.013 11.013 0 0 1 1 12zm2 0a9 9 0 1 0 9-9 9.01 9.01 0 0 0-9 9zm11 0a1 1 0 0 0 1-1 1 1 0 0 1 2 0 1 1 0 0 0 2 0 3 3 0 0 0-6 0 1 1 0 0 0 1 1zm-7-1a1 1 0 0 1 2 0 1 1 0 0 0 2 0 3 3 0 0 0-6 0 1 1 0 0 0 2 0z"
        />
      </svg>
    )
  }
}

export default StylizedEmoji
